// Libraries
import { Injectable } from '@angular/core';
// Menu for application
import { Menu, MENUS } from '../models/Menu';
import { CAMPUS_INFOS } from '../models/CampusInfo';
// Lodash
import * as _ from 'lodash';

@Injectable()
export class MenuService {
    
	/**
	 * Find in the menu type list the menu list that has 
	 * the name matched with menuType input
	 * @param {string} menuType - the name of the menu list
	 * @return { Menu[] | [] } - list of menu or empty list
	 */
	getMenuList(menuType: string) {
		
		let result = _.find(MENUS, {'name': menuType});

		return result ? result.menuList : [];
	}

	getCampusInfo() {
		return CAMPUS_INFOS;
	}
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/MenuService.ts